<template>
  <div ref="comp">
    <b-field label="Zu analysierender Text">
      <b-input type="textarea" v-model="text" custom-class="is-uppercase" />
    </b-field>

    <p><strong>Relative Häufigkeiten in Prozent</strong></p>
    <p>Die gelben Balken zeigen die relativen Häufigkeiten Buchstaben im eingegeben Text an.
       Zusätzlich dargestellt in blau sind die Referenzhäufigkeiten für deutschen Text.</p>
    <svg :width="width" :height="height" v-if="width > 0">
      <path v-for="i in yLabels" :key="'stroke-' + i"
            :d="'M ' + barStart + ' ' + labelYPos(i) + ' L ' + width + ' ' + labelYPos(i)"
            style="stroke-width:1px; stroke:#ccc" />
      <text v-for="(letter, i) in letters" :key="'letter-' + letter"
            :x="i * barWidth + barWidth/2 + i * barSpacing + barStart"
            y="0"
            :dy="height"
            text-anchor="middle"
            :style="'font: normal ' + fontSize + 'px sans-serif'">{{ letter }}</text>
      <text v-for="i in yLabels" :key="'label-' + i"
            dominant-baseline="middle" x="0" y="0"
            :dy="labelYPos(i)"
            style="font: normal 16px sans-serif; fill:#777">
            {{ i * 5 }}</text>
      <rect v-for="(letter, i) in letters" :key="'freq-' + letter"
            :x="i * barWidth + i * barSpacing + barStart + barStrokeWidth / 2"
            :y="height - textFrequencies[letter] * barHeightFactor - fontSize + barStrokeWidth / 2"
            :width="barWidth"
            :height="Math.max(textFrequencies[letter] * barHeightFactor - barStrokeWidth, 0)"
            :style="'fill:#f8e7b277;stroke:#edc240;stroke-width:' + barStrokeWidth"
            @click="tooltip"/>
      <rect v-for="(letter, i) in letters" :key="'reffreq-' + letter"
            :x="i * barWidth + i * barSpacing + barStart + barStrokeWidth / 2"
            :y="height - refFrequencies[letter] * barHeightFactor - fontSize + barStrokeWidth / 2"
            :width="barWidth"
            :height="Math.max(0, refFrequencies[letter] * barHeightFactor - barStrokeWidth)"
            :style="'fill:#dfeffc55;stroke:#b2d8f6;stroke-width:' + barStrokeWidth" />
    </svg>
  </div>
</template>

<script>
const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
                 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
const refFreqencies = {
  "A": 0.0651, "B": 0.0189, "C": 0.0306, "D": 0.0508, "E": 0.1740, "F": 0.0166,
  "G": 0.0301, "H": 0.0476, "I": 0.0755, "J": 0.0027, "K": 0.0121, "L": 0.0344,
  "M": 0.0253, "N": 0.0978, "O": 0.0251, "P": 0.0079, "Q": 0.0002, "R": 0.0700,
  "S": 0.0727, "T": 0.0615, "U": 0.0435, "V": 0.0067, "W": 0.0189, "X": 0.0003,
  "Y": 0.0004, "Z": 0.0113}

export default {
  data () {
    return {
      text: '',
      letters: letters,
      width: 0,
      height: 300,
      barSpacing: 7,
      fontSize: 14,
      barStart: 35,
      barStrokeWidth: 2,
      refFrequencies: refFreqencies
    }
  },
  computed: {
    textFrequencies() {
      let freqs = {}
      let numValidCharacters = 0;
      letters.forEach(function(letter) {
        freqs[letter] = 0
      });
      [...this.text.toUpperCase()].forEach(function(letter) {
        if (freqs.hasOwnProperty(letter)) {
          freqs[letter] += 1
          numValidCharacters += 1
        }
      });
      if (numValidCharacters == 0) {
        numValidCharacters = 1
      }
      for (const letter in freqs) {
        freqs[letter] /= numValidCharacters;
      }
      return freqs
    },
    numYLabels() {
      let freqMaxValue = Math.max(...Object.values(this.textFrequencies))
      let refMaxValue = Math.max(...Object.values(this.refFrequencies))
      let maxValue = Math.max(freqMaxValue, refMaxValue)
      return parseInt(maxValue * 100 / 5) + 1
    },
    yLabels() {
      let step = 1
      let result = []
      if (this.numYLabels > 10) {
        step = 2
      }
      for (let i = 0; i < this.numYLabels; i += step) {
        result.push(i)
      }
      return result
    },
    nextFivePerc() {
      return this.numYLabels * 5 / 100
    },
    barHeightFactor() {
      return (1 / this.nextFivePerc) * (this.height - this.fontSize)
    },
    barWidth() {
      let numLetters = this.letters.length;
      let width = ((this.width - this.barStart + this.barSpacing/2) / numLetters) - this.barSpacing;
      if (width < 0) {
        width = 1;
      }
      return width;
    }
  },
  methods: {
    updateWidth() {
      this.width = this.$refs.comp.clientWidth;
    },
    labelYPos(i) {
      return this.height - this.fontSize - (i / this.numYLabels) * (this.height - this.fontSize)
    },
    tooltip() {
      console.log(this)
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth.bind(this));
    this.updateWidth();
  }
}
</script>
